document.addEventListener("click", function (e) {
  const btn = e.target.closest("[bss-b2b-btn-quickview]");
  if (!btn) return;
    setTimeout(() => {
        document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`)) 
    }, 2000);
});

const isPDP = window.location.pathname.includes("/products/");
if (isPDP) {
    let oldHref = location.href;
    new MutationObserver(() => {
        if (oldHref !== location.href) {
            oldHref = location.href;
            const variant = new URL(location.href).searchParams.get('variant');
            setTimeout(() => {
                const productForm = document.querySelector("[bss-b2b-main-product-form]");
                BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
                    productForm
                });
            }, 600)
        }
    }).observe(document, {
        subtree: true,
        childList: true
    });
} 


document.addEventListener("click", function (e) {
  const btn = e.target.closest(".product-form__item");
  if (!btn) return;

    setTimeout(() => {
        const productForm = document.querySelector("[bss-b2b-quickview-product-form]");
        BSS_B2B.observer.productSubject.notifyObserver('VariantChange', 'VariantSelectChange', {
            productForm
        });
    }, 600)
});

